import React from 'react';
import './styling.css';

function CheckboxComponent({ question, checked, onChange }) {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.checked, e);
    }
  };

  // Parse text with markdown-style links [Link Text](URL) into HTML
  const parseTextWithLinks = (text) => {
    if (!text) return text;
    
    const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = linkRegex.exec(text)) !== null) {
      if (match.index > lastIndex) {
        parts.push(text.substring(lastIndex, match.index));
      }
      
      const linkText = match[1];
      const url = match[2];
      parts.push(
        <a
          key={match.index}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#0066cc', textDecoration: 'underline' }}
        >
          {linkText}
        </a>
      );
      
      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length) {
      parts.push(text.substring(lastIndex));
    }

    return parts.length > 0 ? parts : text;
  };

  const labelContent = parseTextWithLinks(question.Text);

  return (
    <div className="checkbox-component">
      <label>
        <input
          type="checkbox"
          className="checkbox-input"
          checked={checked}
          onChange={handleChange}
        />
        <span>{labelContent}</span>
      </label>
    </div>
  );
}

export default CheckboxComponent;
